import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import { TruncatedTextWithTooltip } from '../../molecules/TruncatedTextWithTooltip'
import UserInfoTable from '../forms/UserInfoTable'
import EditButton from '../../molecules/buttons/EditButton'
import DeleteButton from '../../molecules/buttons/DeleteButton'
import Table from '../../atoms/table/Table'
import Tr from '../../atoms/table/Tr'
import Th from '../../atoms/table/Th'
import Td from '../../atoms/table/Td'
import { requestCountText } from '../../../utils/helpers'
import useSearchParams from '../../../hooks/useSearchParams'

const EnabledProcedureManagementsTable = ({ enabledProcedureManagements = [], onDestroy }) => {
  const urlParams = useSearchParams()
  const hasBranchOfficeFilter = urlParams.has('branch_office_id')
  return (
    <div className="pt-8 pb-2">
      <Table
        className="table-fixed lg:w-full"
        values={enabledProcedureManagements}
        head={
          <Tr body={false}>
            <Th className="w-4">ID</Th>
            <Th className="w-52">Nombre</Th>
            {!hasBranchOfficeFilter && <Th className="w-36">Sede</Th>}
            <Th className="w-44">Creación</Th>
            <Th className="w-44">Actualización</Th>
            <Th className="w-36">Publicación</Th>
            <Th className="w-36">Solicitudes</Th>
            <Th className="w-44">Acciones</Th>
          </Tr>
        }
        body={enabledProcedureManagements.map(row => (
          <Tr key={row.id}>
            <Td>{row.id}</Td>
            <Td>
              <TruncatedTextWithTooltip text={row.name}>
                {props => (
                  <Link to={`gestiones-de-tramites-habilitadas/${row.id}/vista-previa`} {...props}>
                    {row.name}
                  </Link>
                )}
              </TruncatedTextWithTooltip>
            </Td>
            {!hasBranchOfficeFilter && <Td>{row.branch_office_name}</Td>}
            <Td>
              <UserInfoTable
                date={row.created_at}
                name={row.creator_name}
                eliminatorName={row.creator_eliminator_name}
                eliminatedName={row.eliminated_creator_name}
              />
            </Td>
            <Td>
              <UserInfoTable
                date={row.updated_at}
                name={row.updater_name}
                eliminatorName={row.updater_eliminator_name}
                eliminatedName={row.eliminated_updater_name}
              />
            </Td>
            <Td>{row.published ? 'Publicado' : 'No publicado'}</Td>
            <Td>
              <Link
                to={`/gestiones-de-tramites-habilitadas/${row.id}/solicitudes?branch_office_id=${
                  row.branch_office_id || ''
                }`}
              >
                {requestCountText(row.procedures_count)}
              </Link>
            </Td>
            <Td>
              <EditButton to={`/gestiones-de-tramites-habilitadas/${row.id}/editar`} />
              <DeleteButton onClick={() => onDestroy(row)} />
            </Td>
          </Tr>
        ))}
      />
    </div>
  )
}

export default EnabledProcedureManagementsTable

EnabledProcedureManagementsTable.propTypes = {
  enabledProcedureManagements: PropTypes.arrayOf(PropTypes.object),
  onDestroy: PropTypes.func.isRequired
}
